export const SET_WALLET_DETAILS = "CRYPTO_SET_WALLET";
export const SET_WALLET_STATUS = "CRYPTO_SET_WALLET_STATUS";
export const SET_SPEND_ALLOWANCE = "CRYPTO_SET_SPEND_ALLOWANCE";
export const SET_PAYMENT_DETAILS = "CRYPTO_SET_PAYMENT_DETAILS";
export const SET_ERROR = "CRYPTO_SET_ERROR";
export const CLEAR_STATE = "CRYPTO_CLEAR";